export const SAVE_USER_THEME = '/accounts/v1/users/preferences/';
export const FORMS = '/form-runtime/v1/forms';
export const MENU = '/accounts/v1/roles/menu';